<template>
  <div>
    <div v-if="content.news_pic != ''" class="inf_focus_zt">
      <div class="bd">

        <!-- <img :src="content.news_pic" @load="loadImage"> -->
        <van-image class="van_img" lazy-load :src="content.news_pic" @load="loadImage">
          <div class="active_news">
            <div v-if="content.news_stitle != ''" class="active_pic_subtitle">
              <span>
                {{ content.news_stitle }}
              </span>
            </div>
            <div v-if="content.news_title != ''" class="active_pic_title">
              <span class="left_line" /><i class="line_garden" />
              {{ intercept(content.news_title, 10) }}
              <i class="line_garden" /><span class="right_line" />
            </div>
            <div v-if="content.news_subtitle != ''" class="active_pic_subhead">
              {{ content.news_subtitle }}
            </div>
          </div>
          <div v-if="content.news_title != ''" class="top_mask" />
        </van-image>

      </div>
    </div>

    <div v-if="content.new_lead_top != ''" v-lazy-container="{ selector: 'img' }"
      :class="{ 'inf_con_zt': true, 'no_top_contetn': new_lead_top_class_is }" v-html="content.new_lead_top" />
    <div v-else class="inf_noe" />

    <!-- 内容的展示列表 -->
    <div id="ylist" class="y_list">
      <ul>
        <!-- type类型 1菜品，2资讯/专题，3视频，4百科，5文本，6直播，7用户 -->
        <li v-for="(item, index) in dataList" :key="index">
          <div v-if="item.type == 1">
            <a :href="item.link">
              <div class="img">
                <!-- <img v-lazy="item.pic" alt=""> -->
                <van-image class="van_img" lazy-load :src="item.pic" />
                <img v-if="item.icon != ''" :src="item.icon" alt="" class="i_b">
              </div>
              <div class="con">
                <h3>{{ item.title }}</h3>
                <div class="y_list_txt"><span>{{ item.zan }}赞&emsp;{{ item.comment_sum }}评论</span>
                  <div class="ova">
                    <h2>{{ item.nick_name }}</h2>
                  </div>
                </div>
                <div class="hed">
                  <!-- <img v-lazy="item.head_pic"> -->
                  <van-image :src="item.head_pic" />
                  <img v-if="item.isauth == 1" src="https://static.mingchu.co/other/auth_icon_32.png" class="hed_v">
                </div>
              </div>
            </a>
          </div>
          <div v-if="item.type == 2" class="lor">
            <a :href="item.link">
              <div class="img">
                <van-image class="van_img" lazy-load :src="item.pic" />
              </div>
              <div class="con">
                <h5 :class="{ vivocolr: androidshow }"><span>{{ item.title }}</span></h5>
                <h4 :class="{ vivocolr: androidshow }">{{ item.stitle }} {{ formatTime(item.time, 'Y/M/D') }} </h4>
              </div>
            </a>
          </div>
          <div v-if="item.type == 3" class="lor-live">
            <a :href="item.link">
              <div class="img">
                <!-- <img v-lazy="item.pic"> -->
                <van-image class="van_img" lazy-load :src="item.pic" />
                <a class="btn_play" />
                <div class="mask_b">{{ formatSeconds(item.video_time) }} </div>
              </div>
              <h2>{{ item.title }}</h2>
            </a>
          </div>
          <div v-if="item.type == 4" class="lor">
            <a :href="item.link" :class="{ topline: index == 0 }">
              <div v-lazy-container="{ selector: 'img' }" class="img">
                <img data-src="https://img.mingchu.co/Nuploads/NewsImage/5d1d60833152a.jpg" alt="">
              </div>
              <div class="con">
                <div class="h7"><span> <span class="con_subtitle">
                      <span class="con_baike">
                        百科
                      </span>
                    </span>{{ item.title }}</span></div>
                <div class="h8"><span style="-webkit-box-orient: vertical;">{{ item.stitle }}</span></div>
                <h6>查看更多</h6>
              </div>
            </a>
          </div>
          <div v-if="item.type == 5" class="lor-con">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
    <!-- 内容的展示列表 非markdown end -->

    <div v-lazy-container="{ selector: 'img' }" class="g_edit_txt" v-html="content.new_lead_down" />

    <!-- 往期专题展示样式，非列表 -->
    <div v-show="content.past_articles.length" v-lazy-container="{ selector: 'img' }" class="wqzt">
      <img class="ic01" data-src="https://static.mingchu.co/webapp/images/img/topic_icon_pot.png">
      <h3>往期专题 </h3>
      <img class="ic02" data-src="https://static.mingchu.co/webapp/images/img/topic_icon_splitline.png">
      <div v-for="item in content.past_articles" :key="item.id">
        <h4><a :href="item.link"> {{ item.news_title }}</a></h4>
      </div>
    </div>
    <!-- 往期专题展示样式，非列表 end -->
    <div class="lineming" />
  </div>
</template>

<script setup>

// import utils from '@/utils/utils'
import { ref, onMounted, watch, reactive, defineEmits, defineProps } from 'vue'
import { Image as vanImage } from 'vant'
const emits = defineEmits(['onFinish'])
const props = defineProps({
  content: { // 内容对象
    type: Object,
    default: () => { }
  },
  list: {
    type: Array,
    default: () => []
  }
})
let dataList = reactive([])

watch(() => props.list, (newVal, oldVal) => { // 监听一下传进来的数据，异步传值问题
  console.log('temp1-props.list', newVal)
  dataList = newVal
}, { immediate: true })

const new_lead_top_class_is = ref(true)
// const past_articlesShow = ref(false)

let patt = '</p>'
patt = new RegExp(patt)
if (patt.test(props.content.new_lead_top)) {
  new_lead_top_class_is.value = false
}

// 兼容 vivo x21
const androidshow = ref(false)
const str = 'VIVO X21'
const userAgent = navigator.userAgent.toUpperCase()
const strapp = 'GREATCHEF'
if (userAgent.indexOf(str) >= 0) {
  if (userAgent.indexOf(strapp) >= 0) {
    androidshow.value = true
  }
}

// 兼容 vivo x21 end

onMounted(() => {
  emits('onFinish', false)
  // console.log('content1', props.content, props.list)
  // past_articlesShow.value = props.content.contentpast_articles.length > 0
})

const loadImage = (value) => {
  console.log('图片加载完成', value)
  emits('onFinish', false)
}
const intercept = (str, n) => {
  if (typeof (str) !== 'undefined') {
    if (str.length <= n) {
      return str
    } else {
      return str.substr(0, 8) + '...'
    }
  }
}
const formatTime = (number, format) => {
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
  var returnArr = []

  var date = new Date(number * 1000)
  returnArr.push(date.getFullYear())
  returnArr.push(formatNumber(date.getMonth() + 1))
  returnArr.push(formatNumber(date.getDate()))

  returnArr.push(formatNumber(date.getHours()))
  returnArr.push(formatNumber(date.getMinutes()))
  returnArr.push(formatNumber(date.getSeconds()))
  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i])
  }
  return format.replace(/\//g, '.')
}
const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

const formatSeconds = (value) => {
  var theTime = parseInt(value)// 秒
  var middle = 0// 分
  var hour = 0// 小时

  if (theTime > 60) {
    middle = parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (middle > 60) {
      hour = parseInt(middle / 60)
      middle = parseInt(middle % 60)
    }
  }
  var result = '' + parseInt(theTime)
  if (middle > 0) {
    result = '' + parseInt(middle) + ':' + result
  }
  if (hour > 0) {
    result = '' + parseInt(hour) + ':' + result
  }
  return result
}

</script>
